/*eslint  @typescript-eslint/no-use-before-define: 0*/

import _ from "lodash";
import { DataOptions } from "vuetify";
import { defineModule } from "direct-vuex";
import { FILTER_NAMES } from "@/static/filterNames";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { CostDocumentBuffer, CostDocumentBufferResponse } from "@/models/api/costDocumentsOther/CostDocumentBuffer";
import { assignCostDocument, getCostDocumentsBuffer, assignToBooking } from "@/requests/buffer";
import { COST_DOCUMENT_TYPES } from "@/static/costDocumentTypes";

export interface BufferStateInterface {
  bufferList: Array<CostDocumentBuffer>;
  bufferCount: number;
  bufferOptions: DataOptions;
  bufferFilters: Array<CriterionItemRequest> | null;
}

export const BufferState: BufferStateInterface = {
  bufferList: [],
  bufferCount: 0,
  bufferOptions: new DefaultDataOptions(),
  bufferFilters: null,
};

const BufferModule = defineModule({
  state: BufferState as BufferStateInterface,
  modules: {},
  namespaced: true as const,
  getters: {},
  mutations: {
    setBufferList(state, param: CostDocumentBufferResponse) {
      state.bufferList = param.items;
      state.bufferCount = param.totalCount;
    },
    setBufferOptions(state, param: DataOptions) {
      state.bufferOptions = JSON.parse(JSON.stringify(param));
    },
    setBufferFilters(state, param: Array<CriterionItemRequest>) {
      state.bufferFilters = param;
    },
  },
  actions: {
    async getCostDocumentsBuffer(context) {
      const { commit, state } = _moduleActionContext(context);
      const response = await getCostDocumentsBuffer({
        count: state.bufferOptions.itemsPerPage,
        page: state.bufferOptions.page - 1,
        criterions: _.cloneDeep(state.bufferFilters),
        filterName: FILTER_NAMES.CostDocumentBuforStandardFilter,
      });
      commit.setBufferList(response);
    },
    async assignCostDocument(context, params: { costDocumentId: string; type: COST_DOCUMENT_TYPES }) {
      const { dispatch } = _moduleActionContext(context);
      await assignCostDocument(params.costDocumentId, params.type);
      await dispatch.getCostDocumentsBuffer();
    },
    async assignToBooking(context, params: { costDocumentId: string; reservationNumber: string }) {
      await assignToBooking(params.costDocumentId, params.reservationNumber);
    },
  },
});

export default BufferModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, BufferModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, BufferModule);
